// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xBaseTheme } from "@steiner/XDL/types";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        mergeCss: true,
        color: "text.link",
        icon: {
            iconProps: {
                mergeCss: true,
                size: 12,
                color: "common.ui8",
            },
        },
        typographyProps: {
            size: 16,
            weight: fontConfig.weight.semiBold,
            lineHeight: "19px",
        },
        css: css`
            &,
            & > ${TypographyStyle}, & > ${IconWrapper} {
                transition: all ${getProp("theme.transition.duration.short")}ms ease-in-out;
            }

            &:disabled {
                opacity: 0.33;
                cursor: not-allowed;
            }

            & > ${IconWrapper} {
                opacity: 0.66;
            }

            &:not([disabled]):hover {
                & > ${TypographyStyle}, & > ${IconWrapper} {
                    color: ${color("common.ui9")};
                }
            }

            &.small {
                & > ${TypographyStyle} {
                    font-size: ${fontConfig.fontSize.small}px;
                    line-height: ${fontConfig.lineHeight.small};
                }
            }

            &.xSmall {
                & > ${TypographyStyle} {
                    font-size: ${fontConfig.fontSize.xSmall}px;
                    line-height: ${fontConfig.lineHeight.xSmall};
                }
            }
        `,
    },
} as xBaseTheme["link"];
